import React from 'react';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';



const ConfirmationText = () => {

	return (
		<Box p={1}>
			<Typography  paragraph variant='body1' align='justify' >
				<b>I understand that while in a Federal facility I must follow the COVID-19 workplace safety protocols required by the Federal agency I am visiting or for which I am performing contract work onsite. This includes wearing a mask when required in the facility, including when the COVID-19 Community Level in the county where the Federal facility is located is HIGH as defined by the CDC.</b>
			</Typography>
			<Typography paragraph variant='body1' align='justify'>
				<b>If I am not fully vaccinated or decline to provide my vaccination status, I understand the Federal agency I am visiting or for which I am performing contract work onsite may require that I be able to provide proof of a negative COVID-19 test I received within the previous 3 days, including when the COVID-19 Community Level in the county where the Federal facility is located is MEDIUM or HIGH as defined by the CDC.</b>
			</Typography>
			<Typography variant='body1' align='justify' gutterBottom>
			I sign this document under penalty of perjury that the above is true and correct, and that I am the person named below.
			I understand that a knowing and willful false statement on this form can be punished by fine or imprisonment or both (18 U.S.C. 1001).
			Checking “I decline to respond” does not constitute a false statement.
			I understand that if I am a Federal employee or contractor making a false statement on this form could result in additional administrative action, including an adverse personnel action up to and including removal from my position or removal from a contract.
			</Typography>
		</Box>
	);
};

export default ConfirmationText;